<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Pay"
      />
      <h1>
        Pay
      </h1>
      <table>
        <tbody>
          <tr>
            <th>
              <img
                alt="iDeal"
                :src="require('@/images/ideal_logo.png')"
              >
            </th>
            <td>
              <Button
                title="Pay With iDeal"
                @click="payRedirect('IDEAL')"
              />
            </td>
          </tr>
          <tr>
            <th>
              <img
                alt="KBC"
                :src="require('@/images/kbc_logo.png')"
              >
            </th>
            <td>
              <Button
                title="Pay With KBC"
                @click="payRedirect('KBC')"
              />
            </td>
          </tr>
          <tr>
            <th>
              <img
                alt="PayPal"
                :src="require('@/images/paypal_logo.png')"
              >
            </th>
            <td>
              <Button
                title="Pay With PayPal"
                @click="payRedirect('PAYPAL')"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </VerticalNavigator>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import ErrorModal from "@/components/modals/error.vue"
  import {Payment as PaymentClient} from "@/endpoints/rutsolve/gql/resolvers/payment"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {PaymentRedirectInput} from "@/endpoints/rutsolve/gql/generated/graphql"
  import Button from "@/components/button.vue"
  import {useRoute} from "vue-router"

  const error = ref<Error>(null)
  const orderID = ref<string>(null)
  const paymentClient = new PaymentClient()

  onBeforeMount(() => {
    orderID.value = useRoute().params.orderID.toString()
  })

  async function payRedirect(method: string) {
    try {
      const failure = `${process.env.VUE_APP_RUTSOLVE_REST_PAYMENT}/buckaroo/failure/${orderID.value}`
      const success = `${process.env.VUE_APP_RUTSOLVE_REST_PAYMENT}/buckaroo/success/${orderID.value}`
      const input: PaymentRedirectInput = {
        method: method,
        orderID: orderID.value,
        pushFailure: failure,
        pushSuccess: success,
        returnURL: success,
        returnURLCancel: failure,
        returnURLError: failure,
        returnURLReject: failure
      }
      const url = await paymentClient.redirect(input)
      if (url) {
        window.location.replace(url)
      }
    } catch (e) {
      error.value = e
    }
  }
</script>

<style scoped>
  table > tbody > tr {
    > td {
      text-align: right;
    }

    > th {
      text-align: left;

      img {
        max-height: 5em;
      }
    }
  }
</style>
